export default function Contact() {
  return (
    <section id="contact" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-6 text-white md:px-0 space-y-4">
        <div className="text-center mx-auto container font-bold text-4xl md:text-5xl mb-16 md:mt-20 max-w-6xl md:px-0 animate__animated custom-delay-5">
          Get In <span className="text-[#f15700]">Touch</span>
          <div className="w-20 h-1.5 bg-[#f15700] rounded-full mx-auto mt-6"></div>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-12 mt-12">
          <div className="flex items-center space-x-4 bg-white/[0.03] border border-white/10 px-8 py-6 rounded-2xl hover:border-[#f15700]/50 transition-all duration-300 animate__animated custom-delay-6">
            <div className="w-12 h-12 rounded-full bg-[#f15700]/20 flex items-center justify-center text-[#f15700]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l7-7 7 7M5 13v6a2 2 0 002 2h10a2 2 0 002-2v-6M9 22h6"
                ></path>
              </svg>
            </div>
            <div>
              <p className="text-gray-400 text-sm">Location</p>
              <p className="text-lg font-medium">Hyderabad, India</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4 bg-white/[0.03] border border-white/10 px-8 py-6 rounded-2xl hover:border-[#f15700]/50 transition-all duration-300 animate__animated custom-delay-7">
            <div className="w-12 h-12 rounded-full bg-[#f15700]/20 flex items-center justify-center text-[#f15700]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-1 14l-4-4l-.01-2.55l4 4V16zm4 0h2v-6h-2v6z"
                ></path>
              </svg>
            </div>
            <div>
              <p className="text-gray-400 text-sm">Email</p>
              <a
                href="mailto:sashank.pilli@gmail.com"
                className="text-lg font-medium hover:text-[#f15700] transition-colors"
              >
                sashank.pilli@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
